//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import UploadPicture from '../base/uploadPicture';
export default {
  name: 'UploadFroms',
  components: {
    UploadPicture: UploadPicture
  },
  data: function data() {
    return {
      visible: false,
      callback: function callback() {},
      isMore: false,
      modelName: '',
      ISmodal: false,
      booleanVal: false,
      isShowVideo: true
    };
  },
  watch: {
    // show() {
    //   this.visible = this.show
    // }
  },
  methods: {
    handleClose: function handleClose() {
      this.visible = false;
      this.callback(this.visible);
    },
    getImage: function getImage(img) {
      this.callback(img);
      this.visible = false;
    }
  }
};